export const _getItemFromSession = (key: string) => {
  return window.sessionStorage.getItem(key);
};

export const _setItemInSession = (key: string, value: string) => {
  window.sessionStorage.setItem(key, value);
};

export const _removeItemFromSession = (key: string) => {
  window.sessionStorage.removeItem(key);
};

export const deleteFromSS = (key: string) => {
  const ss = window.sessionStorage
  const availableSS = ss.getItem(key);
  if (availableSS) {
    ss.removeItem(key);
  }
};
